import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sizes from './Sizes';
import Modal from '../Modal';
import Price from '../../../utils/Price';


class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rollOut: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSponsorClick = this.handleSponsorClick.bind(this);
    this.handleClubClick = this.handleClubClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({ rollOut: !prevState.rollOut }));
  }

  handleSponsorClick() {
    this.props.updateSponsorLogo({
      productID: this.props.data.id,
      choicesID: this.props.data.choices_id,
      groupID: this.props.groupID,
    });
    this.openModal();
  }

  handleClubClick() {
     this.props.updateCLubLogo({
      productID: this.props.data.id,
      choicesID: this.props.data.choices_id,
      groupID: this.props.groupID,
    });
    this.openModal();
  }

  closeModal() {
    this.setState({ modalActive: false });
  }

  openModal() {
    this.setState({ modalActive: true });
  }

  render() {
    const elementHeight = this.state.rollOut ? `${710 + (60 * this.props.data.sizes.length)}px` : '775px';
    let toggles = this.props.costumizationToggleItems.products.find(
          p => p.productID === this.props.data.id &&
          p.choicesID === this.props.data.choices_id &&
          p.groupID === this.props.groupID,
        );

    if (toggles === undefined) {
      toggles = {
        clubLogo: false,
        sponsorLogo: false,
      };
    }

    return (
      <div className="productContainer" style={{ height: elementHeight }}>
        <div className="topContainer">
          <div className="preTitle">{this.props.customizationTranslations.Customise}</div>
          <div className="groupTitle">{this.props.data.name}</div>
          {this.state.modalActive &&
          <Modal
            content={this.props.customizationTranslations.note}
            closeModal={this.closeModal}
          /> }
        </div>
        <img className={`image ${this.props.data.type}`} src={this.props.data.image} alt="product img" />
        <div className="customizationBox">

          {this.props.data.customizations_available
            .filter((toggleClubLogo, toggleSponsorLogo) => ((toggleClubLogo.type === 'club_logo' || toggleSponsorLogo === 'sponsor_logo') && parseInt(window.siteId, 10) === 10))
            .map(clubLogo => (<div className="textContainerInfo" style={{ padding: '0 13px 5px' }} key={clubLogo}>
                <i>
                  Loggor laddas inte upp här utan ska skickas via e-post.
                  Mer info kommer i ett mejl efter att du slutfört din order.
                </i>
                              </div>))}

          {this.props.settings.groupType === 'brand' && this.props.data.customizations_available
            .filter(toggleClubLogo => toggleClubLogo.type === 'club_logo')
            .map(clubLogo => (
              <div key={this.props.customizationTranslations.AddClublogo} className="buttonGroup">
              <div className="textContainer">
                <div className="header">
                    {this.props.customizationTranslations.AddClublogo}
                  <span className="price">
                      +
                      <Price
                        isTotal
                        isTeamSport
                        priceNet={clubLogo.price}
                        currency={this.props.settings.currency}
                      />
                      {this.props.customizationTranslations.pcs}
                  </span>
                </div>
                <div className="subtitle">{this.props.customizationTranslations.RepresentClub}</div>
              </div>
              <div className="buttonContainer">
                <input
                  id={`club${this.props.data.id + this.props.groupID}`}
                  checked={toggles.clubLogo || false}
                  value={toggles.clubLogo ? 'on' : 'off'}
                  type="checkbox"
                  className="tgl tgl-ios"
                  onChange={this.handleClubClick}
                />
                <label className="tgl-btn" htmlFor={`club${this.props.data.id + this.props.groupID}`} />
              </div>
              </div>
                      ))}

          {this.props.data.customizations_available
            .filter(toggleSponsorLogo => toggleSponsorLogo.type === 'sponsor_logo')
            .map(sponsorLogo => (<div key={this.props.customizationTranslations.AddSponsorLogo} className="buttonGroup">
              <div className="textContainer">
                <div className="header">
                  {this.props.customizationTranslations.AddSponsorLogo}
                  <span className="price">
                    +
                  <Price
                    isTotal
                    isTeamSport
                    priceNet={sponsorLogo.price}
                    currency={this.props.settings.currency}
                  />
                  {this.props.customizationTranslations.pcs}
                  </span>
                </div>
                <div className="subtitle">{this.props.customizationTranslations.sponsorshipText}</div>
              </div>
              <div className="buttonContainer">
                <input
                  id={`sponsor${this.props.data.id + this.props.groupID}`}
                  checked={toggles.sponsorLogo || false}
                  value={toggles.sponsorLogo ? 'on' : 'off'}
                  type="checkbox"
                  className="tgl tgl-ios"
                  onChange={this.handleSponsorClick}
                />
                <label className="tgl-btn" htmlFor={`sponsor${this.props.data.id + this.props.groupID}`} />
              </div>
                                 </div>))}

          {this.props.data.customizations_available
            .filter(toggleSponsorLogo => toggleSponsorLogo.type === 'name')
            .map(name => (<div key={this.props.customizationTranslations.AddPlayername} className="buttonGroup noToggle">
              <div className="textContainer">
                <div className="header">
                  {this.props.customizationTranslations.AddPlayername}
                  <span className="price">
                    +
                    <Price
                      isTotal
                      isTeamSport
                      priceNet={name.price}
                      currency={this.props.settings.currency}
                    />
                    {this.props.customizationTranslations.pcs}
                  </span>
                </div>
                <div className="subtitle">{this.props.customizationTranslations.ChooseBelow}</div>
              </div>
                          </div>))}

          {this.props.data.customizations_available
            .filter(toggleSponsorLogo => toggleSponsorLogo.type === 'number')
            .map(number => (<div key={this.props.customizationTranslations.AddPlayerNumber} className="buttonGroup noToggle">
              <div className="textContainer">
                <div className="header">
                  {this.props.customizationTranslations.AddPlayerNumber}
                  <span className="price">
                  +
                  <Price
                    isTotal
                    isTeamSport
                    priceNet={number.price}
                    currency={this.props.settings.currency}
                  />
                  {this.props.customizationTranslations.pcs}
                  </span>
                </div>
                <div className="subtitle">{this.props.customizationTranslations.ChooseBelow}</div>
              </div>
                            </div>))}
        </div>
        <Sizes
          updateSizeItem={this.props.updateSizeItem}
          customizationsAvailable={this.props.data.customizations_available}
          productType={this.props.data.type}
          productID={this.props.data.id}
          sizes={this.props.data.sizes}
          groupID={this.props.groupID}
          choicesID={this.props.data.choices_id}
        />

        <div
          className={this.state.rollOut ? 'toggleButton expanded' : 'toggleButton'}
          onClick={() => this.handleClick()}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        >
          <span className="arrow" />
        </div>
      </div>
    );
  }
}

const mapDispatch = dispatch => (
  {
    updateCLubLogo: toggleItem => dispatch({
      type: 'UPDATE_CLUB_LOGO_CUSTOMIZATION',
      toggleItem,
    }),
    updateSponsorLogo: toggleItem => dispatch({
      type: 'UPDATE_SPONSOR_LOGO_CUSTOMIZATION',
      toggleItem,
    }),
  }
);

const mapState = state => (
  {
    costumizationToggleItems: state.costumizationToggleItems,
    customizationTranslations: state.customizationTranslations,
    settings: state.settings,
  }
);

export default connect(mapState, mapDispatch)(Product);
